import { render, staticRenderFns } from "./tzproduct6.vue?vue&type=template&id=0a223118&scoped=true"
import script from "./tzproduct6.vue?vue&type=script&lang=js"
export * from "./tzproduct6.vue?vue&type=script&lang=js"
import style0 from "./tzproduct6.vue?vue&type=style&index=0&id=0a223118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a223118",
  null
  
)

export default component.exports